import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "formElement", "display"]
  static values = { replyCreatedAt: Number }
  static EDIT_LIMIT = 3 * 60 * 1000 // 3 minutes in milliseconds

  connect() {
    if (this.formElementTarget) this.formElementTarget.classList.add("hidden")
  }

  edit() {
    if (this.replyCreatedAtValue && Date.now() - this.replyCreatedAtValue > this.constructor.EDIT_LIMIT) return
    if (this.displayTarget) this.displayTarget.classList.add("hidden")
    if (this.formElementTarget) this.formElementTarget.classList.remove("hidden")
    if (this.bodyTarget) {
      this.bodyTarget.focus()
      this.bodyTarget.dataset.originalContent = this.displayTarget?.textContent || ''
    }
  }

  cancel() {
    if (this.formElementTarget) this.formElementTarget.classList.add("hidden")
    if (this.displayTarget) this.displayTarget.classList.remove("hidden")
    if (this.bodyTarget) this.bodyTarget.value = this.bodyTarget.dataset.originalContent || this.bodyTarget.value
  }

  async save(event) {
    event.preventDefault()
    const wrapper = this.formElementTarget
    if (!wrapper) return
    const form = wrapper.querySelector('form')
    if (!(form instanceof HTMLFormElement)) return

    const formData = new FormData(form)

    const response = await fetch(form.action, {
      method: form.method || 'PATCH',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        'Accept': 'application/json'
      }
    })

    if (!response.ok) {
      const data = await response.json().catch(() => ({ errors: ['Failed to update'] }))
      alert("Failed to update")
      return
    }

    const data = await response.json().catch(() => null)
    const newBody = (data && data.body) || formData.get('ticket_reply[body]') || ''

    if (this.displayTarget) this.displayTarget.innerHTML = newBody
    this.formElementTarget.classList.add('hidden')
    if (this.displayTarget) this.displayTarget.classList.remove('hidden')
  }
}
